export const dataTargetItems =
{
    targetId: "1",
    targetName: "Salesforce",
    dataMethod: { id: "GET", name: "GET" },
    dataUrl: "http://target.salesforcetonetsuite.com/test",
    headersdata: [{ headerKey: 1, headervalue: "Headers1" }, { headerKey: 2, headervalue: "Headers2" }, { headerKey: 3, headervalue: "Headers3" }],
    authenticationtype: { id: "basic_auth", name: "Basic Authentication" },
    authenticationsettings: [{ auth_Username: 'Test', auth_password: "Test@123" }],
    contentsettings: [{ contentType: 'Test', messageFormat: "Test" }],
    connectionsettings: [{ maxConnection: 'Test', ObjectName: { id: "cleared_lines", name: "Cleared Lines" } }],
    apiBodyCatalog: { id: "yes", name: "YES" }
}


